// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_crown: PokeData = {
  "id": 1023,
  "name": "iron-crown",
  "height": 16,
  "weight": 1560,
  "base_experience": 295,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "leer",
    "hyper-beam",
    "confusion",
    "slash",
    "metal-claw",
    "future-sight",
    "iron-defense",
    "metal-burst",
    "psycho-cut",
    "flash-cannon",
    "psyshock",
    "quick-guard",
    "volt-switch",
    "sacred-sword",
    "electric-terrain",
    "smart-strike",
    "tachyon-cutter"
  ],
  "moves": [
    "leer",
    "metal-claw",
    "future-sight",
    "metal-burst",
    "volt-switch",
    "electric-terrain",
    "smart-strike",
    "reflect",
    "zen-headbutt",
    "magnet-pull",
    "kinesis",
    "prismatic-cage",
    "iron-defense"
  ],
  "evolution_chain": {
    "id": 546,
    "item": null,
    "species": [
      {
        "name": "iron-crown",
        "order": 1025,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 124,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
